import $ from 'jquery';
import { initPopup } from '@/components/module/popup';

function getCheckValues(checkObjs) {
  return checkObjs.filter(function check() {
    return $(this).is(':checked');
  }).map((_idx, elem) => $(elem).val()).get();
}

function filterValue() {
  const optionCars = $('input[name=carModel]');
  // const optionCategorys = $('input[name=eventCategory]');
  const optionOffers = $('.offers-item');

  const carValues = getCheckValues(optionCars);
  // const categoryValues = getCheckValues(optionCategorys);
  if (carValues.length === 0) {
    optionOffers.show();
  } else {
    optionOffers.each((i, element) => {
      const $element = $(element);
      let isShow = true;
      if ($element.data('carsno') && carValues.length > 0 && $element.data('carsno') !== 'all') {
        const carsnos = $element.data('carsno').toString().split(',');
        if (!optionCars.filter(function check() { return $(this).is(':checked') && carsnos.indexOf($(this).val().toString()) > -1; }).length > 0) {
          isShow = false;
        }
      }
      // if ($element.data('cls') && categoryValues.length > 0) {
      //   if (!optionCategorys.filter(function check() { return $(this).is(':checked') && $(this).val().toString() === $element.data('cls').toString(); }).length > 0) {
      //     isShow = false;
      //   }
      // }
      if (isShow) {
        $element.show();
      } else {
        $element.hide();
      }
    });
  }
}

export function initOffers() {
  const menuClass = '.offers-filter';
  initPopup(menuClass);
  $('.select-block').on('click', 'input[name=carModel]', function click() {
    const id = $(this).attr('id');
    const isChecked = $(`input[id=${id}]`).prop('checked');
    // 針對重複check顯示
    $(`input[id=${$(this).attr('id')}]`).prop('checked', isChecked);
  });

  $(`${menuClass} .pop-up a.remove`).click(() => {
    setTimeout(() => {
      filterValue();
    }, 100);
  });

  $(`${menuClass} .remove-all`).click(() => {
    setTimeout(() => {
      filterValue();
    }, 100);
  });

  $(`${menuClass} .save`).click(() => {
    setTimeout(() => {
      filterValue();
    }, 100);
  });


  $('.unit-list a[data-name=f0]').on('click', () => {
    $('#unit-1').fadeIn(500);
    $('#unit-2').hide();
  });
  $('.unit-list a[data-name=f1]').on('click', () => {
    $('#unit-1').hide();
    $('#unit-2').fadeIn(500);
  });
}
export default {
  initOffers,
};
